import React, { useState } from "react";
import logo from "./assets/logo.png";
import chloe from "./assets/chloe.png";
import group from "./assets/Group.png";
import bell from "./assets/Bell.png";
import { IoIosSearch } from "react-icons/io";
import { HiDotsHorizontal } from "react-icons/hi";

const Sidebar = ({ children, menu }) => {
  const [loanNumbers, setLoanNumbers] = useState(["#000001"]); // Initial loan numbers

  const addNewLoan = () => {
    const nextLoanNumber = `#${(parseInt(loanNumbers[loanNumbers.length - 1].slice(1)) + 1)
      .toString()
      .padStart(6, "0")}`; // Increment loan number
    setLoanNumbers(prevNumbers => [...prevNumbers, nextLoanNumber]); // Add new loan number to state
  };

  return (
    <div className="flex">
      <div
        className={`sidebar h-screen p-4   max-[600px]:absolute  z-20 bg-[#072651] text-white max-w-xl md:block px-4 font-Poppins ${
          menu ? "show" : " "
        }`}
      >
        <div className="flex items-center justify-between border-b border-white mb-4">
          <ul className="flex space-x-4 py-4 items-center">
            <li>
              <img src={logo} width={25} alt="Logo" />
            </li>
            <li>
              <img src={chloe} width={50} alt="Chloe" />
            </li>
          </ul>
          <ul>
            <li>
              <img src={bell} width={40} alt="Bell" />
            </li>
          </ul>
        </div>
        <div className="relative">
          <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
            <IoIosSearch size={25} color="gray" />
          </div>
          <input
            type="search"
            id="default-search"
            className="block p-2 ps-12 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Search"
            required
          />
        </div>
        <div
          className="flex space-x-4 mt-4 text-sm  ml-2 cursor-pointer p-2 hover:bg-[#0C3D81]"
          onClick={addNewLoan}
        >
          <img src={group} width={20} alt="Group" />
          <p> New loan Scenario </p>
        </div>
        <div className="flex flex-col items-center mt-10 space-y-2">
          {loanNumbers.map((loan, index) => (
            <div
              key={index}
              className="flex space-x-32 items-center p-1  hover:bg-[#0C3D81]"
            >
              <p>{loan}</p>
              <HiDotsHorizontal />
            </div>
          ))}
        </div>
      </div>
      <div className="w-full">{children}</div>
    </div>
  );
};

export default Sidebar;
